import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import {
  APP_FILE_CSIO_EDI_LIST,
  APP_FILE_MANAGE_CSIO_EDI,
} from "./csioEDI.constants";

const CSIOEDIList = Loadable(
  lazy(() =>
    import("./CSIOEDIList").then(({ CSIOEDIList }) => ({
      default: CSIOEDIList,
    }))
  )
);

const ManageCSIOEDI = Loadable(
  lazy(() =>
    import("./ManageCSIOEDIWrapper").then(({ ManageCSIOEDIWrapper }) => ({
      default: ManageCSIOEDIWrapper,
    }))
  )
);

export const csioEDIRoutes = [
  {
    path: `${APP_FILE_CSIO_EDI_LIST}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[]} allowFullAccess>
        <CSIOEDIList />
      </AuthorizedRoute>
    ),
  },
  //   {
  //    path: `${APP_FILE_MANAGE_CSIO_EDI}`,
  //    exact: true,
  //    element: (
  //      <AuthorizedRoute moduleKeys={[]} allowFullAccess>
  //        <ManageCSIOEDI />
  //      </AuthorizedRoute>
  //    ),
  //  },
  {
    path: `${APP_FILE_MANAGE_CSIO_EDI}/:messageId`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[]} allowFullAccess>
        <ManageCSIOEDI />
      </AuthorizedRoute>
    ),
  },
];
